import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "BMI",
    isNumber: true,
    isSum: true,
  },
];

const groupOrders = {
  運動狀態: {
    會流汗也會喘: 0,
    會流汗但不會喘: 1,
    不會流汗但會喘: 2,
    不會喘不流汗: 3,
    "不知道、拒答": 4,
  },
};

export const ExerciseHabitsSweatPantToBMI = {
  label: "運動習慣流汗喘息 vs BMI",
  key: "ExerciseHabitsSweatPantToBMI",
  path: "BMI/ExerciseHabitsSweatPantToBMI",
  api: "TCS_V_BMISportQ93V",
  render: (options) => (
    <Diagram.BMI.ExerciseHabitsSweatPantToBMI {...options} />
  ),
  isPercent: true,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupOrders,
  groupColumns: [
    {
      key: "運動狀態",
      field: "運動狀態",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
